// -----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// -----------------------------------------------------------------------
//This fine contains the same logic from isUnsupportedBrowserError in @msstream/shared-services-common', was copy due to dependency issue.
const SafeToLogUnsupportedBrowserMessage: string = '<safe>Unsupported browser</safe>';

export function isUnsupportedBrowserError(message: string): boolean {
  if (
    message === `'ResizeObserver' is undefined` ||
    message === `'ResizeObserver' is not defined` ||
    message === `ResizeObserver is not defined` ||
    message === `Can't find variable: ResizeObserver`
  ) {
    return true;
  }

  if (
    message === `'IntersectionObserver' is undefined` ||
    message === `IntersectionObserver is not defined` ||
    message === `Can't find variable: IntersectionObserver`
  ) {
    return true;
  }

  if (
    message === `'PerformanceObserver' is undefined` ||
    message === `'PerformanceObserver' is not defined`
  ) {
    return true;
  }

  if (message === `function is not a constructor (evaluating 'new EventTarget')`) {
    return true;
  }

  if (message === SafeToLogUnsupportedBrowserMessage) {
    return true;
  }

  if (message && message.includes('setstrings')) {
    return true;
  }

  if (message && message.includes('URL is not supported')) {
    return true;
  }

  if (
    message ===
      `e.addEventListener is not a function. (In 'e.addEventListener("change",m)', 'e.addEventListener' is undefined)` ||
    message === `Object doesn't support property or method 'addEventListener'`
  ) {
    return true;
  }

  if (message === `Performance timeOrigin is not supported`) {
    return true;
  }
  return false;
}
